import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, LOGO_URL } from "../../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("prize_admin_token")) {
      // verify
      api.get("/admin/me").then(() => nav("/admin/dashboard")).catch(() => localStorage.removeItem("prize_admin_token"));
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("prize_admin_token", r.data.token);
      nav("/admin/dashboard");
    } catch (e) {
      setError(e?.response?.data?.detail || "Erro no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F7] p-6" data-testid="admin-login">
      <div className="bg-white p-12 w-full max-w-md">
        <div className="text-center mb-10">
          <div className="flex flex-col items-center leading-none mb-4">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" className="mb-1">
              <path d="M12 2L4 9L12 22L20 9L12 2Z" stroke="#1A1A1A" strokeWidth="1" strokeLinejoin="round"/>
              <path d="M4 9H20" stroke="#1A1A1A" strokeWidth="0.7"/>
            </svg>
            <span className="font-display text-lg tracking-[0.3em]">PRIZE JOIAS</span>
          </div>
          <p className="overline text-[#A8A8A8]">Painel administrativo</p>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="overline text-[#A8A8A8] mb-2 block">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
              className="w-full border border-[#E8E4DF] px-4 py-3 focus:border-[#B8A88A] outline-none"
            />
          </div>
          <div>
            <label className="overline text-[#A8A8A8] mb-2 block">Senha</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
              className="w-full border border-[#E8E4DF] px-4 py-3 focus:border-[#B8A88A] outline-none"
            />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full">
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
